<template>
  <div class="home">
    <v-row class="pt-6 pl-6" dense justify="center">
      <v-col xs="11" sm="8" md="6" lg="5" xl="4" cols="11">
        <span class="title white--text">{{ author }}</span>
      </v-col>
    </v-row>
    <v-row dense class="pl-12" justify="center">
      <v-col xs="11" sm="8" md="6" lg="5" xl="4" cols="11">
        <span class="headline white--text">{{ title }}</span>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col xs="11" sm="8" md="6" lg="5" xl="4" cols="11">
        <div class="d-flex">
          <v-btn color="white" icon x-large @click="playPause()">
            <v-icon x-large>{{ playIcon }}</v-icon>
          </v-btn>
          <v-slider
            style="margin-top: 10px"
            hide-details
            color="white"
            track-color="grey"
            min="0"
            max="100"
            step="1"
            v-model="volume"
          ></v-slider>
          <v-btn color="white" icon x-large @click="muteAudio">
            <v-icon x-large>{{ volumeIcon }}</v-icon>
          </v-btn>
          <!-- <v-badge class="mt-2" overlap :content="listeners" ><v-icon color="white" x-large>mdi-headphones</v-icon></v-badge> -->
          <!-- <v-icon>mdi-headphones</v-icon>23 -->
        </div>
      </v-col>
    </v-row>
    <div class="justify-center">
      <v-tabs
        class="mt-0"
        centered
        background-color="#1a4a7a"
        hide-slider
        color="white"
        v-model="kbps"
      >
        <v-tab class="mt-2">
          <v-badge :content="listeners" v-if="kbps == 0">
            24 kbps
            <v-icon>mdi-headphones</v-icon>
          </v-badge>
          <span v-else>24 kbps</span>
        </v-tab>
        <v-tab class="mt-2">
          <v-badge :content="listeners" v-if="kbps == 1">
            48 kbps
            <v-icon>mdi-headphones</v-icon>
          </v-badge>
          <span v-else>48 kbps</span>
        </v-tab>
        <v-tab class="mt-2">
          <v-badge :content="listeners" v-if="kbps == 2">
            128 kbps
            <v-icon>mdi-headphones</v-icon>
          </v-badge>
          <span v-else>128 kbps</span>
        </v-tab>
      </v-tabs>
    </div>
    <div class="justify-center">
      <v-tabs
        class="mt-0 tbc"
        centered
        center-active
        background-color="#1a4a7a"
        hide-slider
        color="white"
        v-model="day"
      >
        <v-tab
          class="mt-2 pl-0 pr-0"
          :class="{ daytab: $vuetify.breakpoint.xsOnly }"
          v-for="(itm, ind) in weekdays"
          :key="ind"
          >{{ itm }}</v-tab
        >
      </v-tabs>
    </div>
    <v-row dense justify="center">
      <v-col xs="11" sm="8" md="6" lg="5" xl="4" cols="11">
        <v-list class="program" flat>
          <v-list-item
            style="min-height: 32px"
            v-for="itm in this.program[day + 1]"
            :key="itm.time"
            two-line
          >
            <v-list-item-icon class="mt-0 mb-0 program">{{
              itm.time
            }}</v-list-item-icon>
            <v-list-item-content class="program mt-0 pt-0">
              <v-list-item-title class="program">{{
                itm.event
              }}</v-list-item-title>
              <!-- <v-list-item-subtitle class="program">Meditatie</v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <div class="d-none justify-center">
      <audio
        class="mt-4"
        ref="radio"
        id="radio"
        @loadeddata="audioEvents"
        autoplay="true"
        controls="controls"
        @pause="audioPause"
        @play="audioPlay"
      >
        <source :src="audioSrc" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      day: 0,
      volume: 100,
      oldVolume: 100,
      ports: [7000, 7748, 8000],
      streams: ["24", "48", ""],
      days: [6, 0, 1, 2, 3, 4, 5],
      program: {},
      author: "",
      title: "",
      kbps: 2,
      listeners: 0,
      audioSrc: "",
      playIcon: "mdi-play",
      volumeIcon: "mdi-volume-high",
    };
  },
  mounted() {
    //this.audioSrc="https://harta.biz/stream/?date=" + Date.now();
    //console.log('location.protocol ',location.protocol)
    let dat = new Date();
    this.day = this.days[dat.getDay()];
    console.log("day ", this.day);
    this.audioSrc = "https://rod.rod-od.ro:8443/stream?date=" + Date.now();
    // this.audioSrc = "https://rod.rod-od.ro:8443/stream?date=" + Date.now();
    this.getStatus();
    this.getProgram();
    setInterval(this.getStatus, 15000);
  },
  watch: {
    kbps() {
      // this.audioSrc =
      //   "https://rod.rod-od.ro:" +
      //   this.ports[this.kbps] +
      //   "/stream?date=" +
      //   Date.now();
      this.audioSrc =
        "https://rod.rod-od.ro:8443/stream" +
        this.streams[this.kbps] +
        "?date=" +
        Date.now();
      this.$refs.radio.load();
      this.getStatus();
    },
    volume() {
      console.log("time ", this.$refs.radio.currentTime);
      this.$refs.radio.volume = this.volume / 100;
      if (this.volume > 70) {
        this.volumeIcon = "mdi-volume-high";
      } else if (this.volume > 30) {
        this.volumeIcon = "mdi-volume-medium";
      } else if (this.volume > 0) {
        this.volumeIcon = "mdi-volume-low";
      } else {
        this.volumeIcon = "mdi-volume-off";
      }
    },
  },
  computed: {
    weekdays() {
      console.log("xsonly ", this.$vuetify.breakpoint.xsOnly);
      if (this.$vuetify.breakpoint.xsOnly)
        return ["L", "M", "M", "J", "V", "S", "D"];
      return [
        "Luni",
        "Marți",
        "Miercuri",
        "Joi",
        "Vineri",
        "Sâmbătă",
        "Duminică",
      ];
    },
  },
  methods: {
    audioEvents() {
      this.$refs.radio.play();
    },
    muteAudio() {
      if (this.volume > 0) {
        this.oldVolume = this.volume;
        this.volume = 0;
      } else if (this.oldVolume > 0) {
        this.volume = this.oldVolume;
      } else {
        this.volume = 100;
      }
    },
    playPause() {
      if (this.$refs.radio.paused) {
        this.$refs.radio.play();
      } else {
        this.$refs.radio.pause();
      }
    },
    audioPlay() {
      this.playIcon = "mdi-pause";
    },
    audioPause() {
      this.playIcon = "mdi-play";
    },
    getStatus() {
      axios
        .get(
          "https://rod.rod-od.ro/radio/status.php?port=" +
            this.ports[this.kbps] +
            "&date=" +
            Date.now()
        )
        .then((response) => {
          this.listeners = response.data.UNIQUELISTENERS;
          let song = response.data.SONGTITLE;
          this.author = song.split("-")[0];
          this.title = song.replace(this.author + "- ", "");
        });
    },
    getProgram() {
      //http://rod128.rod-od.ro/radio/prog.php
      axios
        .get("https://rod.rod-od.ro/radio/progam.php?date=" + Date.now())
        .then((response) => {
          console.log("program ", response);
          this.program = response.data;
        });
    },
  },
};
</script>
<style scoped>
.home {
  height: 100%;
  background-color: #1a4a7a;
}
.program {
  background-color: #1a4a7a !important;
  color: white !important;
}
.daytab {
  min-width: 40px;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: grey;
}
</style>
